// import R from 'ramda';
import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import { uniq, toPairs, fromPairs, filter, compose } from 'ramda';

import * as actions from '../actions';

// import initialState from './initialState';
// import { byId, withFieldsId } from './utils';

// function techDoc(state = initialState.techDoc, action) {
//   switch (action.type) {
//     case REQUEST_TECHDOC_START:
//       return Object.assign({}, state, {
//         isFetching: true,
//         errorMsg: '',
//         data: {},
//       });

//     case REQUEST_TECHDOC_SUCCESS: {
//       const data = action.data;
//       data.template = action.data.business_information_template;
//       data.id = data.technical_information.id;
//       const updatedById = Object.assign({}, state.byId);
//       if (!updatedById[data.id]) {
//         updatedById[data.id] = {};
//       }

//       updatedById[data.id].order = data;
//       const allGroupData = R.filter(R.propEq('type', 'group'),
// data.technical_information.content);
//       const allGroupDataWithCorrectFields = R.map(withFieldsId, allGroupData);
//       const groupFields = R.flatten(R.pluck(('fields'), allGroupData));
//       const allFieldsData = R.filter(R.propEq('type', 'field'),
// data.technical_information.content);
//       updatedById[data.id].order.fields = {};
//       updatedById[data.id].order.groups = R.reduce(byId, {}, allGroupDataWithCorrectFields);
//       updatedById[data.id].order.fields = R.reduce(byId, {},
// R.concat(allFieldsData, groupFields));
//       updatedById[data.id].order.fieldList = R.values(updatedById[data.id].order.fields);
//       return Object.assign({}, state, {
//         isFetching: false,
//         byId: updatedById,
//         errorMsg: '',
//       });
//     }

//     case REQUEST_TECHDOC_ERROR:
//       return Object.assign({}, state, {
//         isFetching: false,
//         errorMsg: action.err.message || process.env.ERR_GENERIC,
//       });

//     case UPDATE_TECHDOC_SUCCESS:
//       return Object.assign({}, state, {
//         isFetching: false,
//       });

//     case UPDATE_TECHDOC_ERROR:
//       return Object.assign({}, state, {
//         isFetching: false,
//         errorMsg: action.err.message || process.env.ERR_GENERIC,
//       });

//     default:
//       return state;
//   }
// }

function byId(state = {}, action) {
  switch (action.type) {
    case actions.REQUEST_TECHDOCLIST_SUCCESS:
    case actions.UPDATE_TECHDOC_SUCCESS:
    case actions.SAVE_TECHDOC_SUCCESS:
      return Object.assign({}, state, action.data.entities.technicalInformations);
    case actions.REQUEST_TECHDOC_SUCCESS:
      return Object.assign({}, state, action.data.response.entities.technicalInformations);
    case actions.CREATE_TECHDOC_SUCCESS:
      return Object.assign({}, state, action.data.response.entities.technicalInformations);
    case actions.REMOVE_TECHDOC_SUCCESS: {
      const isDeletedTechDoc = item => parseInt(item[0], 10) !== action.techDocId;
      const removeDeletedTechDoc = compose(
        fromPairs,
        filter(isDeletedTechDoc),
        toPairs);
      return removeDeletedTechDoc(state);
    }
    case actions.REQUEST_ORDER_SUCCESS:
    case actions.PLACE_ORDER_NATIONAL_SUCCESS:
      return Object.assign({}, state, action.data.response.entities.technicalInformations);
    default:
      return state;
  }
}


function ids(state = [], action) {
  switch (action.type) {
    case actions.REQUEST_TECHDOCLIST_SUCCESS:
      return uniq(Object.assign([], state, action.data.result));
    case actions.REQUEST_TECHDOC_SUCCESS:
    case actions.CREATE_TECHDOC_SUCCESS:
      return uniq(Object.assign([], state, [action.data.response.result]));
    case actions.REMOVE_TECHDOC_SUCCESS:
      return filter(id => id !== action.techDocId, state);
    default:
      return state;
  }
}

function loading(state = false, action) {
  switch (action.type) {
    case actions.REQUEST_TECHDOCLIST_START:
    case actions.REQUEST_TECHDOC_START:
    case actions.CREATE_TECHDOC:
    case actions.REMOVE_TECHDOC_START:
    case actions.UPDATE_TECHDOC:
    case actions.SAVE_TECHDOC_START:
      return true;
    case actions.REQUEST_TECHDOCLIST_SUCCESS:
    case actions.REQUEST_TECHDOCLIST_ERROR:
    case actions.REQUEST_TECHDOC_SUCCESS:
    case actions.REQUEST_TECHDOC_ERROR:
    case actions.CREATE_TECHDOC_SUCCESS:
    case actions.CREATE_TECHDOC_ERROR:
    case actions.REMOVE_TECHDOC_SUCCESS:
    case actions.REMOVE_TECHDOC_ERROR:
    case actions.UPDATE_TECHDOC_SUCCESS:
    case actions.UPDATE_TECHDOC_ERROR:
    case actions.SAVE_TECHDOC_SUCCESS:
    case actions.SAVE_TECHDOC_ERROR:
      return false;
    default:
      return state;
  }
}

function error(state = null, action) {
  switch (action.type) {
    case actions.REQUEST_TECHDOCLIST_START:
    case actions.REQUEST_TECHDOC_START:
    case actions.REQUEST_TECHDOCLIST_SUCCESS:
    case actions.REQUEST_TECHDOC_SUCCESS:
    case actions.CREATE_TECHDOC:
    case actions.CREATE_TECHDOC_SUCCESS:
    case actions.UPDATE_TECHDOC:
    case actions.UPDATE_TECHDOC_SUCCESS:
    case actions.SAVE_TECHDOC_START:
    case actions.SAVE_TECHDOC_SUCCESS:
      return null;
    case actions.REQUEST_TECHDOCLIST_ERROR:
    case actions.REQUEST_TECHDOC_ERROR:
    case actions.CREATE_TECHDOC_ERROR:
    case actions.REMOVE_TECHDOC_ERROR:
    case actions.UPDATE_TECHDOC_ERROR:
    case actions.SAVE_TECHDOC_ERROR:
      return action.err.message || process.env.ERR_GENERIC;
    default:
      return state;
  }
}

const tis = combineReducers({
  byId,
  ids,
  loading,
  error,
});

export default tis;

export const $getTechnicalInformationById = (state, id) => state.technicalInformations.byId[id];
export const $getTecnicalInformations = state => state.technicalInformations.byId;
export const $getLoading = state => state.technicalInformations.loading;

export const getTechnicalInformationById = (state, id) => {
  const $technicalInformation = state.technicalInformations.byId[id];
  return $technicalInformation && Object.assign({}, $technicalInformation);
};

export const getLoading = createSelector(
  $getLoading,
  $loading => $loading);
